export default {
  changeLocale({ commit }, payload) {
    commit("setLocale", payload);
  },
  changeActiveCompany({ commit }, payload) {
    commit("selectCompany", payload);
  },
  addCompanyList({ commit }, payload) {
    commit("setCompanyList", payload);
  },
};
